import Point from '../../Utility/Point';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Interactable from '../../Component/Interactable';
import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import AnimationComponent from '../../Component/Animation';
import PostcardPinComponent from '../../Component/World/PostcardPin';
import SpeechBubble from './SpeechBubble';
import Game from '../../Game';

export enum PostcardPinState {
    UNKNOW,
    READY,
    AVAILABLE,
}

export default class PostcardPin extends GameObject {
    protected onCreate(params: {
        x: number;
        y: number;
        state: PostcardPinState;
        background: string;
        place: 1 | 2 | 3;
        requiredLevel: number;
    }): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);
        this.addComponent<PostcardPinComponent>(PostcardPinComponent, params);
        this.addComponent<Interactable>(Interactable, {
            enabled: true,
            buttonMode: true,
        });

        const shadow = GameObject.Instantiate(Sprite, {
            texture: 'avatar_shadow',
            anchor: new Point(0.5, 0.5),
            scale: new Point(2, 2),
        });
        this.addChild(shadow);

        const pin: Sprite = GameObject.Instantiate(Sprite, {
            name: 'postcardPin',
            texture: 'postcard_pin',
            anchor: new Point(0.5, 1),
            pivot: new Point(0, 20),
        });
        this.addChild(pin);

        const icon: Sprite = GameObject.Instantiate(Sprite, {
            texture:
                params.state === PostcardPinState.UNKNOW
                    ? 'postcard_pin_unknow'
                    : 'postcard_pin_camera',
            position: new Point(0, -110),
            anchor: new Point(0.5, 0.5),
        });
        pin.addChild(icon);

        if (params.state === PostcardPinState.READY) {
            const coins: Sprite = GameObject.Instantiate(Sprite, {
                name: 'postcardCoins',
                texture: 'postcard_pin_coins',
                position: new Point(0, -45),
                anchor: new Point(0.5, 0.5),
            });
            pin.addChild(coins);
        }

        shadow.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'PulseLoop',
            meta: {
                duration: 1000,
                scale1: new Point(2, 2),
                scale2: new Point(2.1, 2.1),
            },
        });

        pin.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'PulseLoop',
            meta: {
                duration: 1000,
                scale1: new Point(1, 1),
                scale2: new Point(1.1, 1.1),
            },
        });

        // Add the speech bubble.
        const speechBubble: SpeechBubble = GameObject.Instantiate(
            SpeechBubble,
            {
                name: 'speechBubble',
                x: 0,
                y: -200,
                text: Game.locale
                    .getText('WinLevelX')
                    .replace('[X]', params.requiredLevel.toString()),
                textStyle: Game.style.getStyle('postcardPin.text'),
                visible: false,
            }
        );
        this.addChild(speechBubble);
    }
}
